import { AppHeader, AppSidebar, AppContent } from "./index"
import { useLocation } from 'react-router-dom';
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { toggleDrawer, openDrawer, closeDrawer } from "../store/features/drawerSlice";
import { openAlert, closeAlert, toggleAlert } from "../store/features/alertSlice";
// RouteGuard.js
import useRouteAccess from '../hooks/useRouteAccess';
import NotFoundPage from './NotFound';
import UnauthorizedAccessPage from './UnauthorizedAccess';
import Login from '../pages/login/Login';
import SecondaryMenu from './menu/SecondaryMenu';


const Main = () => {
    const location = useLocation();
    const { isMatchInRoutes, isMatchInMenu } = useRouteAccess();
    const dispatch = useDispatch();
    const isAlert = useSelector((state) => state.alert);
    const isDrawer = useSelector((state) => state.drawer);

    if (location.pathname === '/' && !localStorage.getItem('token')) {
        return <Login />;
    }

    const handleDrawerToggle = () => {
        if (isDrawer === true) {
            dispatch(closeDrawer());
        } else {
            dispatch(openDrawer());
        }
    };

    const handleAlertToggle = () => {
        if (isAlert === true) {
            dispatch(closeAlert());
        } else {
            dispatch(openAlert());
        }
    };


    // if (!isMatchInRoutes) return <NotFoundPage />;
    // if (!isMatchInMenu) return <UnauthorizedAccessPage />;

    return (
        <Box sx={{ display: "flex" }} id="main-content">
            <CssBaseline />
            <AppHeader drawerToggle={handleDrawerToggle} alertToggle={handleAlertToggle} alertState={isAlert} />
            <AppSidebar alert={isAlert} />
            <SecondaryMenu />
            <AppContent />
        </Box>

    )

};


export default Main;